"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomLabelGrid = void 0;
const tslib_1 = require("tslib");
const catalog_core_1 = require("@tableau/catalog-core");
const catalog_messages_1 = require("@tableau/catalog-messages");
const widgets_datagrid_1 = require("@tableau/widgets-datagrid");
const react_query_1 = require("@tanstack/react-query");
const react_1 = tslib_1.__importDefault(require("react"));
const PlainTextHeader_1 = require("../../dataGrid/headerFormatters/PlainTextHeader");
const DataGridStyles_1 = require("../../style/DataGridStyles");
const Labels_1 = require("../restApi/Labels");
const LabelCategories_1 = require("../shared/LabelCategories");
const LabelValueSticker_1 = require("../shared/LabelValueSticker");
const CustomLabelDialogHelpers_1 = require("./CustomLabelDialogHelpers");
// Cell formatters and columns
function LabelValueCell(labelCategoryPropName, labelValuePropName, isSeverePropName) {
    return (props) => {
        const data = props.row.data;
        return (react_1.default.createElement(LabelValueSticker_1.LabelValueStickerWrapper, { category: data[labelCategoryPropName], value: data[labelValuePropName], isSevere: data[isSeverePropName] }));
    };
}
function LabelMessageCell(messagePropName, luidPropName, labelValuePropName, contentItemPropName, onClose) {
    return (props) => {
        const data = props.row.data;
        return (react_1.default.createElement(CustomLabelDialogHelpers_1.EditMessagePopover, { message: data[messagePropName], luid: data[luidPropName], labelValue: data[labelValuePropName], contentItem: data[contentItemPropName], hideDialog: () => {
                return;
            }, onClose: onClose }));
    };
}
// delete column here
function DeleteCustomLabelCell(luidPropName, labelValuePropName, contentItemPropName, onClose) {
    return (props) => {
        const data = props.row.data;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(CustomLabelDialogHelpers_1.DeleteCustomLabelButton, { luid: data[luidPropName], labelValue: data[labelValuePropName], contentItem: data[contentItemPropName], hideDialog: () => {
                    return;
                }, shouldShowDialog: () => {
                    return !!data['message'];
                }, onClose: onClose })));
    };
}
// columns, rowStore and grid functions
function useColumns(refetch) {
    const labelValueColumn = {
        name: 'labelValue-col',
        dataKey: 'labelValue',
        headerText: catalog_messages_1.Messages.CustomLabelGridLabelValHeader(),
        growToFit: false,
        headerComponent: (0, PlainTextHeader_1.PlainTextHeaderFormatter)(),
        cellComponent: LabelValueCell('category', 'labelValue', 'visiblity'),
        sortable: false,
        maxColumnWidth: 162,
        preferredWidth: 162,
    };
    const messageColumn = {
        name: 'message-col',
        dataKey: 'message',
        headerText: catalog_messages_1.Messages.CustomLabelGridMessageHeader(),
        growToFit: true,
        headerComponent: (0, PlainTextHeader_1.PlainTextHeaderFormatter)(),
        cellComponent: LabelMessageCell('message', 'luid', 'labelValue', 'contentItem', refetch),
        sortable: false,
    };
    const deleteColumn = {
        name: 'delete-col',
        dataKey: '',
        headerText: catalog_messages_1.Messages.Remove(),
        growToFit: false,
        headerComponent: (0, PlainTextHeader_1.PlainTextHeaderFormatter)(),
        cellComponent: DeleteCustomLabelCell('luid', 'labelValue', 'contentItem', refetch),
        sortable: false,
        maxColumnWidth: 54,
        preferredWidth: 54,
    };
    return [
        labelValueColumn,
        messageColumn,
        deleteColumn,
    ];
}
function convertLabelTypeToRowDataType(label, contentName) {
    var _a;
    return {
        key: label.id,
        data: {
            luid: label.id,
            labelValue: label.value,
            message: (_a = label.message) !== null && _a !== void 0 ? _a : null,
            category: label.category,
            visibility: 'Standard',
            contentItem: {
                contentId: label.contentId,
                contentType: label.contentType,
                contentName,
            },
        },
    };
}
function generateRowStore(rows) {
    return {
        getItems: (start, end, rowHandler) => {
            rowHandler(rows);
        },
    };
}
function useRowGeneration(contentItem) {
    var _a;
    const currentLabelsQueryFn = (0, catalog_core_1.useRestFn)(Labels_1.getLabels);
    const { data, error, isLoading, refetch } = (0, react_query_1.useQuery)(['labels', contentItem.contentType, contentItem.contentId], () => currentLabelsQueryFn({ contentItems: [contentItem], transform: (t) => t }));
    if (error) {
        return { isLoading: false, rows: [] };
    }
    const rows = ((_a = data === null || data === void 0 ? void 0 : data.get({
        contentId: contentItem.contentId,
        contentType: contentItem.contentType.toLowerCase(),
    })) !== null && _a !== void 0 ? _a : [])
        .filter(({ category }) => !(0, LabelCategories_1.isBuiltInLabelCategory)(category))
        .sort((a, b) => a.value.localeCompare(b.value))
        .map(label => { var _a; return convertLabelTypeToRowDataType(label, (_a = contentItem.contentName) !== null && _a !== void 0 ? _a : ''); });
    return { isLoading, rows, refetch };
}
function CustomLabelGrid({ contentItem }) {
    const { rows, refetch } = useRowGeneration(contentItem);
    const refetchOnClose = react_1.default.useCallback(() => {
        if (refetch) {
            void refetch();
        }
    }, [refetch]);
    const cols = useColumns(refetchOnClose);
    const dataGridProps = {
        cols,
        rowStore: generateRowStore(rows),
        showRowBanding: false,
        showHorizontalGridLines: false,
        showVerticalGridLines: false,
        config: {
            colsPerChunk: 3,
        },
        showHeaders: true,
        headerHeight: 30,
        style: { overflow: 'unset', zIndex: 'auto', height: 400 },
    };
    return (react_1.default.createElement(DataGridStyles_1.CustomLabelsDataGridContainer, null,
        react_1.default.createElement(widgets_datagrid_1.DataGrid, Object.assign({}, dataGridProps))));
}
exports.CustomLabelGrid = CustomLabelGrid;
//# sourceMappingURL=CustomLabelDialogGrid.js.map